import { Facebook, Search, Target, BarChart3 } from "lucide-react";

const services = [
  {
    icon: Facebook,
    title: "Facebook Ads Management",
    desc: "We create and optimize high-converting Facebook & Instagram campaigns that drive sales and leads.",
  },
  {
    icon: Search,
    title: "Google Ads Management",
    desc: "Capture high-intent customers through powerful Google Search, Display, and YouTube campaigns.",
  },
  {
    icon: Target,
    title: "Conversion Optimization",
    desc: "We optimize your landing pages and funnels to increase conversions and reduce ad costs.",
  },
  {
    icon: BarChart3,
    title: "Analytics & Scaling",
    desc: "Advanced tracking, performance analysis, and scaling strategies to grow profitable campaigns.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-mono tracking-widest text-[#FF5722] uppercase mb-4">
            // Our Services
          </div>
          <h2
            data-testid="services-heading"
            className="text-4xl sm:text-5xl md:text-6xl font-bold tracking-tight text-white"
          >
            Our Core <span className="gradient-text">Services</span>
          </h2>
          <p className="mt-5 text-lg text-zinc-400 max-w-2xl">
            End-to-end paid advertising solutions designed to drive measurable growth.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {services.map((s, i) => (
            <div
              key={i}
              data-testid={`service-card-${i}`}
              className="group relative rounded-2xl bg-[#0c0c0c] border border-white/[0.06] p-7 hover:border-[#FF5722]/40 hover:-translate-y-1.5 transition-all duration-300 overflow-hidden"
            >
              <div className="absolute -top-20 -right-20 w-40 h-40 bg-[#FF5722]/0 group-hover:bg-[#FF5722]/10 blur-3xl transition-all duration-500" />

              <div className="relative">
                <div className="w-12 h-12 rounded-xl bg-[#FF5722]/10 border border-[#FF5722]/20 flex items-center justify-center mb-5 group-hover:bg-[#FF5722] group-hover:scale-110 transition-all duration-300">
                  <s.icon className="w-5 h-5 text-[#FF5722] group-hover:text-black transition-colors" strokeWidth={2.2} />
                </div>
                <h3 className="text-xl font-semibold text-white mb-3 tracking-tight">
                  {s.title}
                </h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>

                <div className="mt-6 flex items-center text-xs font-mono text-zinc-600 group-hover:text-[#FF7043] transition-colors">
                  <span className="w-6 h-px bg-current mr-2" />
                  0{i + 1}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
